import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formInput } from 'actions/FormActions';
import { showSnackbar } from 'actions/CommonActions';
import { IconButton, Paper } from '@mui/material';
import { SvgIcon } from '@mui/material';
import { AddStoreLockDateNTime, deleteStoreLockDateNTime, updateStoreLockDateNTime } from 'actions/EntityActions';
class StoreLockDateAndTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dayTimeSelections: {},
      preOpenTime: 0,
      preCloseTime: 0,
      addTime: false
    };
    this.sectionRefs = [];
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  /**
    * @param {number} day - The index of the day in the week (Sunday = 0, Monday = 1, etc.)
    */
  handleTimeChange = (e, day) => {
    const { value } = e.target;
    const timeType = e.target.getAttribute('data-type');
    this.setState(prevState => ({
      dayTimeSelections: {
        ...prevState.dayTimeSelections,
        [day]: {
          ...prevState.dayTimeSelections[day],
          [timeType]: value
        }
      }
    }), () => {
    });
  };
  convertTo24Hour = (time) => {
    const [hours, minutesPeriod] = time.split(':');
    const [minutes, period] = minutesPeriod.split(' ');
    let h = parseInt(hours, 10);
    if (period === 'PM' && h < 12) h += 12;
    if (period === 'AM' && h === 12) h = 0;
    return `${h < 10 ? '0' + h : h}:${minutes}:00`;
  };
  convertTo12Hour = (timeStr) => {
    const [hour, minutes] = timeStr.split(":");
    let period = "AM";
    let hour12 = parseInt(hour, 10);
    if (hour12 >= 12) {
      period = "PM";
      if (hour12 > 12) hour12 = hour12 % 12;
    }
    if (hour12 === 0) hour12 = 12;
    return `${hour12}:${minutes} ${period}`;
  };
  addOpenOrCloseTimeSpan = (day) => {
    const dayData = this.state.dayTimeSelections[day];
    const { openingHour, closingHour } = dayData;
    const { AddStoreLockDateNTime, branchId, showSnackbar } = this.props;
    if (openingHour && closingHour) {
      const opening24Hour = this.convertTo24Hour(openingHour);
      const closing24Hour = this.convertTo24Hour(closingHour);
      if (closing24Hour <= opening24Hour) {
        showSnackbar("Error! Closing time cannot be earlier than or equal to opening time.");
        return;
      }
      const createStoreLockAndTimeModel = {
        Weekday: day,
        StartTime: opening24Hour,
        EndTime: closing24Hour,
        UnlockBeforeStart: 0,
        LockBeforeEnd: 0,
        BranchId: branchId
      };
      AddStoreLockDateNTime(createStoreLockAndTimeModel);
    } else {
      showSnackbar("Please fill both Open Time and Close Time before submit");
    }
  };
  deleteOpenOrCloseTimeSpan = (day) => {
    const { deleteStoreLockDateNTime, branchId } = this.props;
    deleteStoreLockDateNTime({
      Weekday: day,
      BranchId: branchId
    });
  };
  updateDayTimeSelectionsStateValue = (e, storeLockDateAndTimeLists, day) => {
    const timeType = e.target.getAttribute('data-type');
    if (timeType === "storeLockDateAndTimeListsStartTime") {
      this.setState(prevState => ({
        dayTimeSelections: {
          ...prevState.dayTimeSelections,
          [day]: {
            ...storeLockDateAndTimeLists[day],
            ...prevState.dayTimeSelections[day],
            storeLockDateAndTimeListsStartTime: true
          }
        }
      }));
    } else if (timeType === "storeLockDateAndTimeListsEndTime") {
      this.setState(prevState => ({
        dayTimeSelections: {
          ...prevState.dayTimeSelections,
          [day]: {
            ...storeLockDateAndTimeLists[day],
            ...prevState.dayTimeSelections[day],
            storeLockDateAndTimeListsEndTime: true
          }
        }
      }));
    }
  };
  updateOpenOrCloseTimeSpan = (day) => {
    const { dayTimeSelections } = this.state;
    const { updateStoreLockDateNTime, branchId, showSnackbar } = this.props;
    if (dayTimeSelections[day].openingHour && dayTimeSelections[day].closingHour) {
      const opening24Hour = this.convertTo24Hour(dayTimeSelections[day].openingHour);
      const closing24Hour = this.convertTo24Hour(dayTimeSelections[day].closingHour);
      if (closing24Hour <= opening24Hour) {
        showSnackbar("Error! Closing time cannot be earlier than or equal to opening time.");
        return;
      }
      const updateStoreLockDateNTimeModel = {
        Weekday: day,
        StartTime: opening24Hour,
        EndTime: closing24Hour,
        UnlockBeforeStart: 0,
        LockBeforeEnd: 0,
        BranchId: branchId
      };
      updateStoreLockDateNTime(updateStoreLockDateNTimeModel);
      this.setState(prevState => ({
        dayTimeSelections: {
          ...prevState.dayTimeSelections,
          [day]: {
            ...prevState.dayTimeSelections[day],
            storeLockDateAndTimeListsStartTime: false,
            storeLockDateAndTimeListsEndTime: false
          }
        }
      }));
    } else {
      showSnackbar("Error Update! Please Select Both Opening Hours And Closing Hours!");
    }
  };
  handleOutsideClick = (e) => {
    if (this.sectionRefs.every(ref => ref && !ref.contains(e.target))) {
      this.setState(prevState => {
        const updatedDayTimeSelections = { ...prevState.dayTimeSelections };
        Object.keys(updatedDayTimeSelections).forEach(day => {
          updatedDayTimeSelections[day].storeLockDateAndTimeListsStartTime = false;
          updatedDayTimeSelections[day].storeLockDateAndTimeListsEndTime = false;
        });
        return { dayTimeSelections: updatedDayTimeSelections };
      });
    }
  };
  render() {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const timeOptions = [...Array.from({ length: 24 * 4 }, (_, i) => {
      const hour = Math.floor(i / 4) % 12 || 12;
      const minute = (i % 4) * 15;
      const period = Math.floor(i / 48) === 0 ? 'AM' : 'PM';
      return `${hour}:${minute.toString().padStart(2, '0')} ${period}`;
    })];
    const { storeLockDateAndTimeLists } = this.props;
    const { dayTimeSelections } = this.state;
    return (
      <Paper style={{ padding: 16, minWidth: "720px", maxWidth: "720px", marginRight: "auto" }}>
        <section className="StoreLockDateAndTime-header-container" style={{ borderBottom: "1px solid #E3E3E3" }}>
          <h3 style={{ marginTop: "0", fontWeight: "600", textAlign: "center" }}>Store Operation Hours Settings</h3>
          <h5 style={{ margin: "0", marginBottom: "5px", fontSize: "15px", textAlign: "center" }}>Enable Store Operation Hours: Set the open and close times. Outside these hours, or if left blank, the web store will be locked.</h5>
        </section>
        <section className="StoreLockDateAndTime-body-container" style={{ display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "space-between" }}>
          {days.map((day, i) => {
            return (
              <section key={day} style={{ height: "42px", width: "100%", margin: "10px 0" }} ref={ref => { this.sectionRefs[i] = ref; }}>
                <div style={{ height: "100%", borderBottom: "1px solid #E3E3E3", display: "flex", alignItems: "center" }}>
                  <h5 style={{ fontWeight: "600", fontSize: "27px", margin: "0", minWidth: "15%" }} className="col-sm-1 p-0">{day}</h5>
                  <section style={{ display: 'flex', justifyContent: 'space-between', minWidth: "35%", alignItems: "center", backgroundColor: "#abffc7", borderRadius: "10px", marginBottom: "10px" }}>
                    {/*OPENING HOUR---------------------------------------------------------------------*/}
                    {!storeLockDateAndTimeLists || !storeLockDateAndTimeLists[i] || (this.state.dayTimeSelections[i] && this.state.dayTimeSelections[i].storeLockDateAndTimeListsStartTime) ?
                      <section style={{ display: 'flex', width: "100%", alignItems: "center", marginLeft: "5px" }}>
                        <div style={{ flex: 1, paddingLeft: "5px", display: 'flex', flexDirection: 'column', justifyContent: "center", height: '40px', width: "100%" }}>
                          <select value={this.state.openingHour} onChange={(e) => this.handleTimeChange(e, i)}
                            data-type="openingHour"
                            style={{ width: '90px', height: '30px', margin: 0, border: "1px solid #787878", borderRadius: "6%", textAlign: 'center' }}>
                            <option value=""></option>
                            {timeOptions.map((time) =>
                              <option key={time} value={time}>{time}</option>
                            )}
                          </select>
                        </div>
                      </section> :
                      <section style={{ display: 'flex', width: "100%", alignItems: "center", marginLeft: "5px" }}>
                        <div style={{ flex: 1, paddingLeft: "5px", display: 'flex', flexDirection: 'column', justifyContent: "center", height: '40px', width: "100%" }}>
                          <span data-type="storeLockDateAndTimeListsStartTime" onClick={e => this.updateDayTimeSelectionsStateValue(e, storeLockDateAndTimeLists, i)} style={{ fontSize: "20px", fontWeight: "bolder" }}>{this.convertTo12Hour(storeLockDateAndTimeLists[i].startTime)}</span>
                        </div>
                      </section>}
                    {/*OPENING HOUR---------------------------------------------------------------------*/}
                    <div style={{ display: 'flex', justifyContent: "center", width: "10%", paddingLeft: "5px" }}>
                      <SvgIcon >
                        <path fill="green" d="M12,2 L12,22 L22,12 L12,2 Z M2,12 L12,12 L12,14 L4,14 L4,10 L12,10 L12,12 L2,12 Z"></path>
                      </SvgIcon>
                    </div>
                    {/*ClOSE HOUR---------------------------------------------------------------------*/}
                    {!storeLockDateAndTimeLists || !storeLockDateAndTimeLists[i] || (this.state.dayTimeSelections[i] && this.state.dayTimeSelections[i].storeLockDateAndTimeListsEndTime) ?
                      <section style={{ display: 'flex', width: "100%", alignItems: "center", marginRight: "10px" }}>
                        <div style={{ flex: 1, paddingLeft: "5px", display: 'flex', flexDirection: 'column', justifyContent: "center", height: '40px', width: "100%" }}>
                          <select value={this.state.closingHour} onChange={(e) => this.handleTimeChange(e, i)}
                            data-type="closingHour"
                            style={{ width: '90px', height: '30px', margin: 0, border: "1px solid #787878", borderRadius: "6%", textAlign: 'center' }}>
                            <option value=""></option>
                            {timeOptions.map((time) =>
                              <option key={time} value={time}>{time}</option>
                            )}
                          </select>
                        </div>
                      </section> :
                      <section style={{ display: 'flex', width: "100%", alignItems: "center", marginLeft: "5px" }}>
                        <div style={{ flex: 1, paddingLeft: "5px", display: 'flex', flexDirection: 'column', justifyContent: "center", height: '40px', width: "100%" }}>
                          <span data-type="storeLockDateAndTimeListsEndTime" onClick={e => this.updateDayTimeSelectionsStateValue(e, storeLockDateAndTimeLists, i)} style={{ fontSize: "20px", fontWeight: "bolder" }}>{this.convertTo12Hour(storeLockDateAndTimeLists[i].endTime)}</span>
                        </div>
                      </section>}
                    {/*ClOSE HOUR---------------------------------------------------------------------*/}
                  </section>
                  {!storeLockDateAndTimeLists || !storeLockDateAndTimeLists[i] ?
                    <IconButton
                      style={{
                        borderRadius: '50%',
                        padding: 0,
                        border: '3px solid green',
                        width: '33px',
                        height: '33px',
                        marginLeft: 42,
                        marginBottom: 12,
                      }}
                      onClick={() => this.addOpenOrCloseTimeSpan(i)}
                    >
                      <SvgIcon style={{ width: '15px', height: '15px' }}>
                        <path fill="green" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                      </SvgIcon>
                    </IconButton>

                    :
                    (dayTimeSelections && dayTimeSelections[i] &&
                      (dayTimeSelections[i].storeLockDateAndTimeListsEndTime === true) &&
                      (dayTimeSelections[i].storeLockDateAndTimeListsStartTime === true)) ?
                      <IconButton
                        style={{ borderRadius: '50%', padding: '0px', border: '3px solid blue', width: '33px', height: '33px', marginLeft: "42px", marginBottom: "12px" }}
                        onClick={() => this.updateOpenOrCloseTimeSpan(i)}>
                        <SvgIcon style={{ width: '15px', height: '15px' }}>
                          <path fill="blue" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-.5-13h-1v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
                        </SvgIcon>

                      </IconButton> :
                      <IconButton
                        style={{ borderRadius: '50%', padding: '0px', border: '3px solid red', width: '33px', height: '33px', marginLeft: "42px", marginBottom: "12px" }}
                        onClick={() => this.deleteOpenOrCloseTimeSpan(i)}>
                        <SvgIcon style={{ width: '15px', height: '15px' }}>
                          <path fill="red" d="M19 13H5v-2h14v2z" />
                        </SvgIcon>

                      </IconButton>}
                </div>
              </section>
            );
          })}
        </section>
      </Paper>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    branchId: state.common.branchId,
    storeLockDateAndTimeLists: state.entity.storeLockDateAndTimeLists
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    AddStoreLockDateNTime: (model) => dispatch(AddStoreLockDateNTime(model)),
    deleteStoreLockDateNTime: (model) => dispatch(deleteStoreLockDateNTime(model)),
    updateStoreLockDateNTime: (model) => dispatch(updateStoreLockDateNTime(model))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(StoreLockDateAndTime);
